import React, { useState, useContext } from 'react';
import FigureCard from './FigureCard';
import FigureCardMultiple from './FigureCardMultiple';
import { SystemSettingsContext } from '../../../../contexts/SystemSettingsContext';

// ASSP-7733 Add financialStats for FigureCards
//
const BreakdownFiguresB = ({
    order = {},
    performanceStats = [],
    deliveryStats,
    financialStats,
    setFinancialStats,
 }) => {
    const { formatNumber } = useContext(SystemSettingsContext);

    const handleReach = (stats) => {
        setFinancialStats({ ...financialStats, reach: stats})
    }

    const handleOTH = (stats) => {
        setFinancialStats({ ...financialStats, oth: stats})
    }

    console.log('BreakdownFiguresB financialStats deliveryStats', financialStats, deliveryStats)

    return (
        <div>
            <div style={{ display: 'flex', width: '100%', columnGap: 11 }}>
                <FigureCardMultiple
                    title='Spots'
                    figure1={deliveryStats?.deliveredSpots}
                    figure2={deliveryStats?.bookedSpots}
                    figure3={deliveryStats?.scheduledSpots}
                    metric=''
                />
                <FigureCardMultiple
                    title='Reach'
                    figure1={
                        financialStats.reach === 'percent'
                            ? deliveryStats?.deliveredReachPct
                            : deliveryStats?.deliveredReach
                    }
                    figure2={
                        financialStats.reach === 'percent'
                            ? deliveryStats?.bookedReachPct
                            : deliveryStats?.bookedReach
                    }
                    figure3={
                        financialStats.reach === 'percent'
                            ? deliveryStats?.scheduledReachPct
                            : deliveryStats?.scheduledReach
                    }
                    decimals={1}
                    metric={financialStats.reach === 'percent' ? '%' : ''}
                    radioItems={[
                      { id: 'total', label: 'Total'},
                      { id: 'percent', label: 'Percent'}
                    ]}
                    radioValue={financialStats.reach}
                    radioClick={handleReach}
                />

                <FigureCardMultiple
                    title='OTH'
                    figure1={
                        financialStats.oth === 'weekly'
                            ? deliveryStats?.deliveredWeeklyOTH
                            : deliveryStats?.deliveredOTH
                    }
                    figure2={
                        financialStats.oth === 'weekly'
                            ? deliveryStats?.bookedWeeklyOTH
                            : deliveryStats?.bookedOTH
                    }
                    figure3={
                        financialStats.oth === 'weekly'
                            ? deliveryStats?.scheduledWeeklyOTH
                            : deliveryStats?.scheduledOTH
                    }
                    decimals={1}
                    metric=''
                    radioItems={[
                      { id: 'overall', label: 'Overall'},
                      { id: 'weekly', label: 'Weekly'}
                    ]}
                    radioValue={financialStats.oth}
                    radioClick={handleOTH}
                />
            </div>
        </div>
    );
};

export default BreakdownFiguresB;
